import React, { useState } from 'react';
import styles from './style.module.css';
import moment from 'moment';
import styled from 'styled-components';
import { v3_followUp_add } from '../../../../actions/v3/dashboard';
import { ToastContainer, toast } from 'react-toastify'

const DirectMessageButton = styled.button`
  background-color: #1A3F80 !important;
  color: #fff;
  border: none;
  padding: 10px 10px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
`;
const Detail = ({ label, value }) => {
    return (
        <div className={`${styles.detail} ${styles.detailBox}`}>
            <span className={styles.labeleHead}>{label}:</span>{' '}
            <span className={styles.valueLable}>{value}</span>
        </div>
    );
};

const Header = ({ label }) => {
    return (
        <div className={`${styles.detail} ${styles.detailBox}`}>
            <span className={styles.labeleHead}>{label}</span>
        </div>
    );
};

const JoiningFollowup = ({ data, close }) => {
    const [newFollowup, setNewFollowup] = useState('');

    const handleSave = () => {
        if (newFollowup.trim()) {
            v3_followUp_add({
                applicationId: data.APPLICATION_ID,
                followUpDetail: newFollowup.trim(),
            }).then((res) => {
                if (res.status) {
                    toast.success('Follow-up saved successfully!');
                    setNewFollowup('');
                    close();
                } else {
                    toast.error(res.error || 'Failed to save follow-up.');
                }
            }).catch((err) => {
                toast.error(err?.message || 'Something went wrong.');
            });
        }
    };

    return (
        <div className={styles.profilViewModalSection}>
            <ToastContainer />

            <div className="popupCandidateFormStyle">
                <div className={styles.modalCandidateBox}>
                    <div className={styles.whatppBox}>
                        <Header className={styles.labelNotify} label={data.FULL_NAME} />
                    </div>
                </div>

                <div className={`${styles.detailscontainer} ${styles.detailscontainerBox}`}>
                    <Detail label="Email" value={data.EMAIL} />
                    <Detail label="Phone" value={data.PHONE} />
                    <Detail label="Company Name" value={data.COMPANY_NAME} />
                    <Detail label="Job Title" value={data.JOB_TITLE} />
                    <Detail label="Recruiter Name" value={data.RECRUITER_NAME} />
                    <Detail label="Joining Date" value={moment(data.ACTUAL_DOJ || data.EXPECTED_DOJ).format('DD-MM-YYYY')} />

                    {/* Previous Follow-ups */}
                    {data?.recentFollowup?.length > 0 && (
                        <>
                            <hr />
                            <Header label="Previous Follow-ups" />
                            <br />
                            {data.recentFollowup.map((item, index) => (
                                <Detail
                                    key={index}
                                    label={`Last follow-up on ${moment(item.CREATED_ON).format('DD-MM-YYYY')}`}
                                    value={item.FOLLOW_UP_DETAIL}
                                />
                            ))}
                        </>
                    )}


                    {/* Add New Follow-up */}
                    <div className={`${styles.detail} ${styles.detailBox}`} style={{ marginTop: '1.5rem' }}>
                        <span className={styles.labeleHead}>Add Follow-up:</span>
                    </div>
                    <textarea
                        className={styles.textareaInput}
                        placeholder="Write follow-up detail here..."
                        value={newFollowup}
                        onChange={(e) => setNewFollowup(e.target.value)}
                        style={{ width: '100%', minHeight: '70px', marginBottom: '10px' }}
                    />

                    <DirectMessageButton onClick={() => { handleSave() }}>Save Follow-up</DirectMessageButton>
                </div>
            </div>
        </div>
    );
};

export default JoiningFollowup;
